import { RowCrudStatus } from "../../common/types";
import {
  TadManagerConfig,
  TadManagerConfigUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { TadAuthProvider } from "../../../api/graphql";
import { IdCardType } from "../../../api/graphql";
import { blankToNull } from "../../../common/blankToNull";
import { Gender } from "../../../api/graphql";

export type TadManagerConfigValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  authProvider: TadAuthProvider | "";
  idCardType: IdCardType | "";
  idCard: string;
  procedureNumber: string;
  procedureNumberHasValue: boolean;
  miArgentinaPassword: string;
  miArgentinaPasswordHasValue: boolean;
  arcaPassword: string;
  arcaPasswordHasValue: boolean;
  ansesPassword: string;
  ansesPasswordHasValue: boolean;
  gender: Gender | "";
};

export type TadManagerConfigErrorsType = {
  authProvider?: { message: string; fieldLabel: string };
  idCardType?: { message: string; fieldLabel: string };
  idCard?: { message: string; fieldLabel: string };
  procedureNumber?: { message: string; fieldLabel: string };
  miArgentinaPassword?: { message: string; fieldLabel: string };
  arcaPassword?: { message: string; fieldLabel: string };
  ansesPassword?: { message: string; fieldLabel: string };
  gender?: { message: string; fieldLabel: string };
};

export function TadManagerConfigValuesInit(): TadManagerConfigValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    authProvider: "renaper" as TadAuthProvider,
    idCardType: "cuitCuil" as IdCardType,
    idCard: "",
    procedureNumber: "",
    procedureNumberHasValue: false,
    miArgentinaPassword: "",
    miArgentinaPasswordHasValue: false,
    arcaPassword: "",
    arcaPasswordHasValue: false,
    ansesPassword: "",
    ansesPasswordHasValue: false,
    gender: "" as Gender | "",
  };
}

export type TadManagerConfigType =
  | TadManagerConfig
  | TadManagerConfigValuesType;

export function tadManagerConfigDisplayId(
  source: Partial<TadManagerConfig>,
  _langStore: LangStore
) {
  return source.idCard ?? _langStore.emptyStringSymbol;
}

export function getTadManagerConfigValues(
  source: TadManagerConfigType,
  _langStore: LangStore,
  _duplicated: boolean = false
): TadManagerConfigValuesType {
  const entityValues = TadManagerConfigValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : tadManagerConfigDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.authProvider =
    source.authProvider || ("" as TadAuthProvider | "");
  entityValues.idCardType = source.idCardType || ("" as IdCardType | "");
  entityValues.idCard = source.idCard || "";
  entityValues.procedureNumber = "";
  entityValues.procedureNumberHasValue = !!source.procedureNumberHasValue;
  entityValues.miArgentinaPassword = "";
  entityValues.miArgentinaPasswordHasValue =
    !!source.miArgentinaPasswordHasValue;
  entityValues.arcaPassword = "";
  entityValues.arcaPasswordHasValue = !!source.arcaPasswordHasValue;
  entityValues.ansesPassword = "";
  entityValues.ansesPasswordHasValue = !!source.ansesPasswordHasValue;
  entityValues.gender = source.gender || ("" as Gender | "");
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getTadManagerConfigUpdateVariables(
  values: TadManagerConfigValuesType
): TadManagerConfigUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    authProvider: values.authProvider || null,
    idCardType: values.idCardType || null,
    idCard: blankToNull(values.idCard),
    procedureNumber: values.procedureNumber || undefined,
    miArgentinaPassword: values.miArgentinaPassword || undefined,
    arcaPassword: values.arcaPassword || undefined,
    ansesPassword: values.ansesPassword || undefined,
    gender: values.gender || null,
  };
}
